import { Form } from "react-bootstrap";
import { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";

const CenterDropdown = ({
  onSelectCenter,
  isEditMode = false,
  selectedCenterId,
  error,
}) => {
  const [selectedCenter, setSelectedCenter] = useState(selectedCenterId || "");

  const centers = [
    {
      center_id: 104,
      center_uuid: "6d296fc7-243b-477b-9947-b011ab872caf",
      name: "Innocent Minds - Bliss",
    },
    {
      center_id: 114,
      center_uuid: "c3d526b0-7699-4d33-9e85-e23693b33524",
      name: "Innocent Minds - Sanayeh",
    },
    {
      center_id: 119,
      center_uuid: "183f02e0-aeb2-4506-b5ba-a170a9149014",
      name: "Innocent Minds-Hazmieh",
    },
  ];

  const handleChange = (e) => {
    const value = e.target.value;
    setSelectedCenter(value);

    const centerObj = centers.find(
      (center) => center.center_id.toString() === value
    );

    if (onSelectCenter) {
      onSelectCenter(centerObj);
    }
  };
  useEffect(() => {
    if (selectedCenterId) {
      setSelectedCenter(selectedCenterId);
    }
  }, [selectedCenterId]);

  return (
    <Form.Group className="position-relative w-100">
      <FormattedMessage id="select_branch" />
      <Form.Select
        value={selectedCenter}
        onChange={handleChange}
        disabled={isEditMode}
        isInvalid={error}
      >
        <option value="">-- Select Center --</option>
        {centers.map((center) => (
          <option key={center.center_id} value={center.center_id}>
            {center.name}
          </option>
        ))}
      </Form.Select>
      <Form.Control.Feedback className="px-3" type="invalid">
        <FormattedMessage id="error.center_id" />
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default CenterDropdown;
